export const TRACK_100_JUMPS = 'track_100_jumps';